module.exports = __webpack_public_path__ + "img/sign_apply_selection.d3dbd5f6.png";